import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';

import RichText from '../../../Core/RichText';

import {
  StyledListItem,
  Card,
  CardImage,
  Overlay,
  StyledLink,
  Content,
  Title,
  HoverLink,
} from './styles';

const Blog = ({ data = null, wide = false }) => {
  if (!data) return null;

  const { id, ariaLabel, headline, imageDam, pageSlug } = data;

  const intl = useIntl();

  return (
    <StyledListItem className={wide ? 'wide' : null} role="listitem">
      <Card key={id}>
        {imageDam && (
          <CardImage
            src={imageDam}
            objectFit="cover"
            style={{ position: 'static' }}
          />
        )}

        <StyledLink
          to={`/learning-hub/blog/${pageSlug}/`}
          aria-label={
            // eslint-disable-next-line no-nested-ternary
            ariaLabel
              ? intl.locale === 'en'
                ? `Read blog article: ${ariaLabel}`
                : `Lire article du blog : ${ariaLabel}`
              : intl.locale === 'en'
                ? `Read blog article`
                : `Lire article du blog`
          }
        >
          &nbsp;
        </StyledLink>
        <Overlay />
        <Content>
          <Title>{headline && <RichText document={headline} />}</Title>
          <HoverLink>
            {intl.locale === 'en' ? `Read Article` : `Lire article`}
          </HoverLink>
        </Content>
      </Card>
    </StyledListItem>
  );
};

Blog.propTypes = {
  data: PropTypes.shape(),
  wide: PropTypes.bool,
};

export default Blog;
